import { FETCH_OMS_ORIGIN } from 'api/OmsOrigins/constants'
import { FETCH_STORES } from 'api/Stores/constants'
import type { Ranges } from 'api/System/types'
import { selectSkipRefetchOmsOrigins } from 'data/selectors'
import { getDateKey } from 'data/utils'
import { createLogic } from 'redux-logic'
import type { State } from 'store/types'
import type { RequestDate } from 'types/UI'

interface FetchAction {
  dateCurrent: RequestDate
  dateCompared?: RequestDate | null
  range: Ranges
}

const parallelFetchStores = createLogic<State, FetchAction>({
  type: FETCH_STORES,
  latest: true,

  async process({ action, getState }, dispatch, done) {
    try {
      const state = getState()
      const dataKey = getDateKey(action.payload)
      const skipRefetch = selectSkipRefetchOmsOrigins({ dataKey, ...action.payload } as any)(state)

      if (!skipRefetch) {
        dispatch({
          type: FETCH_OMS_ORIGIN,
          payload: action.payload,
        })
      }
    } catch (error) {
      // Not interested
    }
    done()
  },
})

export default [parallelFetchStores]
